/**
 * RemoteServerCompleteFailureError
 * Thrown when we get a REMOTE_FAIL_COMPLETE form appserver
 */
export default class RemoteServerCompleteFailureError extends Error {
  
  // TODO: this is duck-typing, because babel is broken
  static type = "RemoteServerCompleteFailureError";
  
  static responseCode = "REMOTE_FAIL_COMPLETE";
  
  constructor(response) {
    super("Appserver failed to communicate with any remote servers.");
    this.response = response;
    this.type = RemoteServerCompleteFailureError.type;
  }
  
}



// WEBPACK FOOTER //
// ./src/lib/appserver/responseExceptions/RemoteServerCompleteFailureError.js